import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-adb5186e")

_pushScopeId("data-v-adb5186e")
const _hoisted_1 = { class: "avatar-container" }
const _hoisted_2 = {
  key: 0,
  class: "closed"
}
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "header-end" }
const _hoisted_7 = {
  key: 0,
  class: "rating"
}
const _hoisted_8 = { style: {"color":"#ffc409"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Novo")
const _hoisted_10 = { class: "subtitle" }
const _hoisted_11 = { class: "tag-container" }
const _hoisted_12 = { class: "tag" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "tag" }
const _hoisted_16 = { class: "tag" }
const _hoisted_17 = {
  key: 1,
  class: "highlight"
}
const _hoisted_18 = { class: "tag-master" }
const _hoisted_19 = {
  key: 0,
  class: "tag-box cashback-box"
}
const _hoisted_20 = {
  key: 1,
  class: "tag-box coupon-box"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_badge = _resolveComponent("ion-badge")
  const _component_ion_card_content = _resolveComponent("ion-card-content")
  const _component_ion_card = _resolveComponent("ion-card")

  return (_openBlock(), _createBlock(_component_ion_card, null, {
    default: _withId(() => [
      _createVNode(_component_ion_card_content, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_ion_img, {
              class: "avatar",
              src: 
            'https://storage.googleapis.com/thelivery/img/clients/' +
            $props.establishment.logo
          
            }, null, 8, ["src"]),
            (!$props.establishment.status)
              ? (_openBlock(), _createBlock("div", _hoisted_2, "Fechado"))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("h3", _hoisted_5, _toDisplayString($props.establishment.name), 1),
              _createVNode("div", _hoisted_6, [
                (!$props.establishment.new && $props.establishment.rating)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode("p", _hoisted_8, _toDisplayString($options.formatRating($props.establishment.rating)), 1),
                      _createVNode(_component_ion_icon, {
                        icon: $setup.star,
                        color: "warning"
                      }, null, 8, ["icon"])
                    ]))
                  : _createCommentVNode("", true),
                ($props.establishment.new)
                  ? (_openBlock(), _createBlock(_component_ion_badge, { key: 1 }, {
                      default: _withId(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("p", _hoisted_10, _toDisplayString($props.establishment.category), 1),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_ion_icon, { icon: $setup.bicycle }, null, 8, ["icon"]),
                ($props.establishment.deliveryFee > 0)
                  ? (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString($options.formatCurrency($props.establishment.deliveryFee)), 1))
                  : (_openBlock(), _createBlock("p", _hoisted_14, "Grátis"))
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode(_component_ion_icon, { icon: $setup.timeOutline }, null, 8, ["icon"]),
                _createVNode("p", null, _toDisplayString($props.establishment.averageTime) + " min", 1)
              ]),
              _createVNode("div", _hoisted_16, [
                ($props.establishment.onlinePayment || $props.establishment.creditCard)
                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                      key: 0,
                      icon: $setup.card
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true),
                ($props.establishment.onlinePayment)
                  ? (_openBlock(), _createBlock("p", _hoisted_17, "Online"))
                  : _createCommentVNode("", true),
                ($props.establishment.pix)
                  ? (_openBlock(), _createBlock(_component_ion_img, {
                      key: 2,
                      class: "logoPix",
                      src: "assets/logoPix.png"
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_18, [
              ($props.establishment.cashbackValue)
                ? (_openBlock(), _createBlock("span", _hoisted_19, _toDisplayString($props.establishment.cashbackValue) + " CASHBACK ", 1))
                : _createCommentVNode("", true),
              ($props.establishment.coupon)
                ? (_openBlock(), _createBlock("span", _hoisted_20, " CUPOM DE " + _toDisplayString($props.establishment.coupon), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})